import { render, staticRenderFns } from "./TheAzureBillingAdjustmentList.vue?vue&type=template&id=a1d1b036&"
import script from "./TheAzureBillingAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./TheAzureBillingAdjustmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports